import React from 'react';
import {  Row, Col} from 'reactstrap';


class DentalVip extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      carrossel: 0,
      vantagens:false,
      vantagensRight:false,
      coberturas:false,
      carencias:false,
      carenciasRight:false,
      familia:false,
    };

    this.styles = {
      
    };
  }
  vantagens(value){
    let state = this.state;
    state.vantagens = value;
    this.setState(state);
  }
  vantagensRight(value){
    let state = this.state;
    state.vantagensRight = value;
    this.setState(state);
  }
  coberturas(value){
    let state = this.state;
    state.coberturas = value;
    this.setState(state);
  }
  carencias(value){
    let state = this.state;
    state.carencias = value;
    this.setState(state);
  }
  carenciasRight(value){
    let state = this.state;
    state.carenciasRight = value;
    this.setState(state);
  }
  familia(value){
    let state = this.state;
    state.familia = value;
    this.setState(state);
  }
  next_carrossel(){
    let state = this.state;
    state.vantagens = false;
    state.vantagensRight = false;
    state.coberturas = false;
    state.carencias = false;
    state.carenciasRight = false;
    state.familia = false;
    state.carrossel = this.state.carrossel+1;
    this.setState(state);
  }
  back_carrossel(){
    let state = this.state;
    state.vantagens = false;
    state.vantagensRight = false;
    state.coberturas = false;
    state.carencias = false;
    state.carenciasRight = false;
    state.familia = false;
    state.carrossel = this.state.carrossel-1;
    this.setState(state);
  }
  jumper_carrossel(number){
    let state = this.state;
    state.carrossel = number;
    this.setState(state);
  }

  render() {
    return (
      <div id="dental_vip">
      <div id="find_dentist_right_detail">&nbsp;</div>
      <div id="find_dentist_left_detail">&nbsp;</div>
        
        <hr className="hr_style"/>
        <div className="dentalvip_img"> 
          {''}
        </div>
        <p className="text_vip">
          O plano com mais vantagens<br/>
          para você e sua família
        </p>

        {/**Tela do tamanho normal */}
        <div className="full_tela">
          {/**-----------------COBERTURAS---------------- */}
          {this.state.carrossel == 0 ? (
            <div style={{marginTop:160}}>
            <div>{''}</div>
            <div className="carrossel">
              {/** icones */}
              <div className="carrossel_top">
                <Row style={{margin:'auto', maxWidth:'95%'}} >
                  <Col>
                    <div onMouseMove={this.jumper_carrossel.bind(this, 0)} className="carrossel_icon_layout carrossel_icon1">{''}</div>
                    <p className="text_legend">COBERTURAS</p>
                  </Col>
                  <Col>
                    <div onMouseMove={this.jumper_carrossel.bind(this, 1)} className="carrossel_icon_layout carrossel_icon_inativo2">{''}</div>
                    <p className="text_legend_inativo">CARÊNCIAS</p>
                  </Col>
                  <Col>
                    <div onMouseMove={this.jumper_carrossel.bind(this, 2)} className="carrossel_icon_layout carrossel_icon_inativo3">{''}</div>
                    <p className="text_legend_inativo">VANTAGENS</p>
                  </Col>
                  <Col>
                    <div onMouseMove={this.jumper_carrossel.bind(this, 3)} className="carrossel_icon_layout carrossel_icon_inativo4">{''}</div>
                    <p className="text_legend_inativo">TABELA FAMÍLIA</p>
                  </Col>
                </Row>
              </div>
              {/** conteudo */}
              <div className="carrossel_bottom">
                <Row>
                  <Col xs="1" sm="1" md="1" lg="1" xl="1">
                    {""}
                  </Col>
                  <Col xs="10" sm="10" md="10" lg="10" xl="10">
                    <Row>
                      <Col xs="12" sm="6" md="6" lg="7" xl="7" className="col_text">
                        <p className="text_list">URGÊNCIA E EMERGÊNCIA</p>
                        <p className="text_list">TRATAMENTO PARA CRIANÇAS (ODONTOPEDIATRIA)</p>
                        <p className="text_list">CONSULTAS</p>
                        <p className="text_list">RESTAURAÇÃO (DENTÍSTICA)</p>
                        <p className="text_list">LIMPEZA, PREVENÇÃO E APLICAÇÃO DE FLÚOR</p>
                      </Col>
                      <Col xs="12" sm="6" md="6" lg="5" xl="5" className="col_text2">
                        <p className="text_list">CIRURGIAS E EXTRAÇÕES</p>
                        <p className="text_list">RAIOS-X (PANORÂMICOS E PERIAPIPCAIS)</p>
                        <p className="text_list">TRATAMENTO DE CANAL (ENDODONTIA)</p>
                        <p className="text_list">TRATAMENTO DE GENGIVA (PERIODONTIA)</p>
                        <p className="text_list">RETIRADA DE PLACA BACTERIANA</p>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs="1" sm="1" md="1" lg="1" xl="1" 
                    onMouseOver={this.coberturas.bind(this, true)} 
                    onMouseOut={this.coberturas.bind(this, false)}>
                    {this.state.coberturas == true ?(
                      <div onClick={this.next_carrossel.bind(this)} className="shape2">
                        <div className="arrow-right-hover">{""}</div>
                      </div>
                    ):(
                      <div onClick={this.next_carrossel.bind(this)} className="shape2">
                        <div className="arrow-right">{""}</div>
                      </div>
                    )}                
                  </Col>                   
                </Row>
              </div>
            </div>
          </div>
          ):('')}
          {/**-----------------CARENCIAS---------------- */}
          {this.state.carrossel == 1 ? (
            <div style={{marginTop:160}}>
              <div>{''}</div>
              <div className="carrossel">
                {/** icones */}
                <div className="carrossel_top">
                  <Row style={{margin:'auto', maxWidth:'95%'}} >
                    <Col>
                      <div onMouseMove={this.jumper_carrossel.bind(this, 0)} className="carrossel_icon_layout carrossel_icon_inativo1">{''}</div>
                      <p className="text_legend_inativo">COBERTURAS</p>
                    </Col>
                    <Col>
                      <div onMouseMove={this.jumper_carrossel.bind(this, 1)} className="carrossel_icon_layout carrossel_icon2">{''}</div>
                      <p className="text_legend">CARÊNCIAS</p>
                    </Col>
                    <Col>
                      <div onMouseMove={this.jumper_carrossel.bind(this, 2)} className="carrossel_icon_layout carrossel_icon_inativo3">{''}</div>
                      <p className="text_legend_inativo">VANTAGENS</p>
                    </Col>
                    <Col>
                      <div onMouseMove={this.jumper_carrossel.bind(this, 3)} className="carrossel_icon_layout carrossel_icon_inativo4">{''}</div>
                      <p className="text_legend_inativo">TABELA FAMÍLIA</p>
                    </Col>
                  </Row>
                </div>
                {/** conteudo */}
                <div className="carrossel_bottom">
                  <Row>
                    <Col xs="1" sm="1" md="1" lg="1" xl="1"
                        onMouseOver={this.carencias.bind(this, true)} 
                        onMouseOut={this.carencias.bind(this, false)}>
                      {this.state.carencias == true ?(
                        <div onClick={this.back_carrossel.bind(this)} className="shape2">
                          <div className="arrow-left-hover">{""}</div>
                        </div>
                      ):(
                        <div onClick={this.back_carrossel.bind(this)} className="shape2">
                          <div className="arrow-left">{""}</div>
                        </div>
                      )}                
                    </Col>     
                    <Col xs="10" sm="10" md="10" lg="10" xl="10">
                      <p className="title_carencia">CARÊNCIAS REDUZIDAS PARA PAGAMENTO NO CARTÃO DE CRÉDITO</p>
                      <Row >
                         <Col xs="10" sm="6" md="6" lg="6" xl="2">
                           {""}
                         </Col>                          
                        <Col xl={10} className="col_text_carencia2" >
                          <table style={{width:'65%'}} align="center">
                            <tbody>
                                <tr>
                                  <td className="td_family">{''}</td>
                                  <td className="td_family"><p className="text_list">URGÊNCIA E EMERGÊNCIA</p> </td>
                                  <td className="td_family" style={{textAlign:'center'}}><p className="text_list">1 MINUTO</p></td>
                                </tr>
                                <tr>
                                <td className="td_family">{''}</td>

                                  <td className="td_family"><p className="text_list">DENTÍSTICA, RADIOLOGIA, DIAGNÓSTICO<br/> E ODONTOLOGIA PREVENTIVA</p></td>
                                  <td className="td_family" style={{textAlign:'center'}}><p className="text_list">1 MINUTO</p></td>
                                </tr>
                                <tr>
                                <td className="td_family">{''}</td>

                                  <td className="td_family"><p className="text_list">PERIODONTIA E ENDODONTIA</p></td>
                                  <td className="td_family" style={{textAlign:'center'}}><p className="text_list">30 DIAS</p> </td>
                                </tr>
                                <tr>
                                <td className="td_family">{''}</td>

                                  <td className="td_family"><p className="text_list">CIRURGIAS</p> </td>
                                  <td className="td_family" style={{textAlign:'center'}}><p className="text_list">60 DIAS</p></td>
                                </tr>
                                <tr>
                                <td className="td_family">{''}</td>

                                  <td className="td_family"><p className="text_list">COROA</p> </td>
                                  <td className="td_family" style={{textAlign:'center'}}><p className="text_list">180 DIAS</p></td>
                                </tr>                                
                            </tbody>
                          </table>
                        </Col>
                      </Row>                      
                      {/*}
                      <Row>
                        <Col xs="12" sm="6" md="6" lg="6" xl="2">
                          {""}
                        </Col>                        
                        <Col  xs="12" sm="6" md="6" lg="6" xl="5" className="col_text">
                          <p className="text_list">URGÊNCIA E EMERGÊNCIA</p>
                          <p className="text_list" >DENTÍSTICA, RADIOLOGIA, DIAGNÓSTICO<br/> E ODONTOLOGIA PREVENTIVA</p>
                          <p className="text_list" >PERIODONTIA E ENDODONTIA</p>
                          <p className="text_list" >CIRURGIAS</p>      
                          <p className="text_list" style={{paddingTop:5}}>COROA</p>                        

                        </Col>
                        <Col  xs="12" sm="6" md="6" lg="6" xl="5" className="col_text2">
                          <p className="text_list">1 MINUTO</p>
                          <p className="text_list" style={{paddingTop:0}}>1 MINUTO</p>
                          <p className="text_list" style={{paddingTop:20}}>30 DIAS</p>
                          <p className="text_list" style={{paddingTop:5}}>60 DIAS</p>     
                          <p className="text_list" style={{paddingTop:0}}>180 DIAS</p>                       
                        </Col>
                      </Row>
                      {*/}
                    </Col>
                    <Col xs="1" sm="1" md="1" lg="1" xl="1"
                        onMouseOver={this.carenciasRight.bind(this, true)} 
                        onMouseOut={this.carenciasRight.bind(this, false)}>
                      {this.state.carenciasRight == true ?(
                        <div onClick={this.next_carrossel.bind(this)} className="shape2">
                          <div className="arrow-right-hover">{""}</div>
                        </div>
                      ):(
                        <div onClick={this.next_carrossel.bind(this)} className="shape2">
                          <div className="arrow-right">{""}</div>
                        </div>
                      )}                
                    </Col>                  
                  </Row>
                </div>
              </div>
            </div>
          ):('')}
          {/**-----------------VANTAGENS---------------- */}
          {this.state.carrossel == 2 ? (
            <div style={{marginTop:160}}>
              <div>{''}</div>
              <div className="carrossel">
                {/** icones */}
                <div className="carrossel_top">
                  <Row style={{margin:'auto', maxWidth:'95%'}} >
                    <Col>
                      <div onMouseMove={this.jumper_carrossel.bind(this, 0)} className="carrossel_icon_layout carrossel_icon_inativo1">{''}</div>
                      <p className="text_legend_inativo">COBERTURAS</p>
                    </Col>
                    <Col>
                      <div onMouseMove={this.jumper_carrossel.bind(this, 1)} className="carrossel_icon_layout carrossel_icon_inativo2">{''}</div>
                      <p className="text_legend_inativo">CARÊNCIAS</p>
                    </Col>
                    <Col>
                      <div onMouseMove={this.jumper_carrossel.bind(this, 2)} className="carrossel_icon_layout carrossel_icon3">{''}</div>
                      <p className="text_legend">VANTAGENS</p>
                    </Col>
                    <Col>
                      <div onMouseMove={this.jumper_carrossel.bind(this, 3)} className="carrossel_icon_layout carrossel_icon_inativo4">{''}</div>
                      <p className="text_legend_inativo">TABELA FAMÍLIA</p>
                    </Col>
                  </Row>
                </div>
                {/** conteudo */}
                <div className="carrossel_bottom">
                  <Row>
                    <Col xs="1" sm="1" md="1" lg="1" xl="1"
                        onMouseOver={this.vantagens.bind(this, true)} 
                        onMouseOut={this.vantagens.bind(this, false)}>
                      {this.state.vantagens == true ?(
                        <div onClick={this.back_carrossel.bind(this)} className="shape2">
                          <div className="arrow-left-hover">{""}</div>
                        </div>
                      ):(
                        <div onClick={this.back_carrossel.bind(this)} className="shape2">
                          <div className="arrow-left">{""}</div>
                        </div>
                      )}                
                    </Col>                  
                    <Col xs="10" sm="10" md="10" lg="10" xl="10">
                      <Row>
                        <Col xl={12} className="col_text_vantagens">
                          <p className="text_list">AMPLA REDE DE DENTISTAS</p>
                          <p className="text_list">ATENDIMENTO EM CLÍNICAS PARTICULARES</p>
                          <p className="text_list">LIBERAÇÃO ONLINE DE PROCEDIMENTOS</p>
                          <p className="text_list">MATERIAIS COM ALTO PADRÃO DE QUALIDADE</p>
                          <p className="text_list">COBERTURA TOTAL PARA MAIS DE 150 PROCEDIMENTOS CLÍNICOS</p>
                        </Col>                      
                      </Row>
                    </Col>
                    <Col xs="1" sm="1" md="1" lg="1" xl="1" 
                        onMouseOver={this.vantagensRight.bind(this, true)} 
                        onMouseOut={this.vantagensRight.bind(this, false)}>
                      {this.state.vantagensRight == true ?(
                        <div onClick={this.next_carrossel.bind(this)} className="shape2">
                          <div className="arrow-right-hover">{""}</div>
                        </div>
                      ):(
                        <div onClick={this.next_carrossel.bind(this)} className="shape2">
                          <div className="arrow-right">{""}</div>
                        </div>
                      )}                
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          ):('')}
          {/**-----------------TABELA FAMILIA---------------- */}
          {this.state.carrossel == 3 ? (
            <div style={{marginTop:160}}>
              <div>{''}</div>
              <div className="carrossel">
                {/** icones */}
                <div className="carrossel_top">
                  <Row style={{margin:'auto', maxWidth:'95%'}} >
                    <Col>
                      <div onMouseMove={this.jumper_carrossel.bind(this, 0)} className="carrossel_icon_layout carrossel_icon_inativo1">{''}</div>
                      <p className="text_legend_inativo">COBERTURAS</p>
                    </Col>
                    <Col>
                      <div onMouseMove={this.jumper_carrossel.bind(this, 1)} className="carrossel_icon_layout carrossel_icon_inativo2">{''}</div>
                      <p className="text_legend_inativo">CARÊNCIAS</p>
                    </Col>
                    <Col>
                      <div onMouseMove={this.jumper_carrossel.bind(this, 2)} className="carrossel_icon_layout carrossel_icon_inativo3">{''}</div>
                      <p className="text_legend_inativo">VANTAGENS</p>
                    </Col>
                    <Col>
                      <div onMouseMove={this.jumper_carrossel.bind(this, 3)} className="carrossel_icon_layout carrossel_icon4">{''}</div>
                      <p className="text_legend">TABELA FAMÍLIA</p>
                    </Col>
                  </Row>
                </div>
                {/** conteudo */}
                <div className="carrossel_bottom">
                  <Row>
                    <Col xs="1" sm="1" md="1" lg="1" xl="1"
                        onMouseOver={this.familia.bind(this, true)} 
                        onMouseOut={this.familia.bind(this, false)}>
                      {this.state.familia == true ?(
                        <div onClick={this.back_carrossel.bind(this)} className="shape2">
                          <div className="arrow-left-hover">{""}</div>
                        </div>
                      ):(
                        <div onClick={this.back_carrossel.bind(this)} className="shape2">
                          <div className="arrow-left">{""}</div>
                        </div>
                      )}                
                    </Col>                  
                    <Col xs="10" sm="10" md="10" lg="10" xl="10">
                      <p className="title_table_family">DESCONTOS A PARTIR DE 2 BENEFICIÁRIOS</p>
                      <p className="title_table_family2">VÁLIDO PARA PAGAMENTOS NO CARTÃO DE CRÉDITO</p>
                      <Row>
                        <Col xl={12} className="col_text_family">
                          <table style={{width:'62%'}}>
                            <thead>
                                <tr >
                                    <th>{''}</th>
                                    <th style={{textAlign:'center', paddingLeft:0}}><div className="th_family">VALOR UNITÁRIO</div></th>
                                    <th style={{textAlign:'center', paddingLeft:10}}><div className="th_family">VALOR TOTAL</div></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                  <td className="td_family">1 BENEFICIÁRIO <hr className="hr_family"/></td>
                                  <td className="td_family" style={{textAlign:'center'}}>R$<span className="td_span">33</span>,90</td>
                                  <td className="td_family">{''}</td>
                                </tr>
                                <tr>
                                  <td className="td_family">2 BENEFICIÁRIOS <hr className="hr_family2"/></td>
                                  <td className="td_family" style={{textAlign:'center'}}>R$<span className="td_span">31</span>,50 <hr className="hr_family4"/></td>
                                  <td className="td_family" style={{textAlign:'center'}}>R$<span className="td_span">63</span>,00</td>
                                </tr>
                                <tr>
                                  <td className="td_family">3 BENEFICIÁRIOS <hr className="hr_family2"/></td>
                                  <td className="td_family" style={{textAlign:'center'}}>R$<span className="td_span">28</span>,30 <hr className="hr_family4"/></td>
                                  <td className="td_family" style={{textAlign:'center'}}>R$<span className="td_span">84</span>,90</td>
                                </tr>
                                <tr>
                                  <td className="td_family">4 BENEFICIÁRIOS OU MAIS <hr className="hr_family3"/></td>
                                  <td className="td_family" style={{textAlign:'center'}}>R$<span className="td_span">28</span>,30</td>
                                  <td className="td_family">{''}</td>
                                </tr>
                            </tbody>
                          </table>
                        </Col>
                      </Row>
                    </Col>
                    <Col xs="1" sm="1" md="1" lg="1" xl="1">
                      {""}             
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          ):('')}
        </div>
        
        {/**Tela pequena */}
        <div className="tela_responsivo">
          {/**-----------------COBERTURAS---------------- */}
          {this.state.carrossel == 0 ? (
            <div style={{marginTop:160}}>
            <div>{''}</div>
            <div className="carrossel">
              {/** icones */}
              <div className="carrossel_top">
                <Row style={{margin:'auto', maxWidth:'95%'}} >
                  <Col>
                    <div onMouseMove={this.jumper_carrossel.bind(this, 0)} className="carrossel_icon_layout carrossel_icon1">{''}</div>
                    <p className="text_legend">COBERTURAS</p>
                  </Col>
                </Row>
              </div>
              {/** conteudo */}
              <div className="carrossel_bottom">
                <Row>
                  <Col xs="2" sm="1" md="1" lg="1" xl="1">
                    {""}
                  </Col>
                  <Col xs="8" sm="10" md="10" lg="10" xl="10">
                    <Row>
                      <Col xs="12" sm="12" md="6" lg="6" xl="7" className="col_text">
                        <p className="text_list">URGÊNCIA E EMERGÊNCIA</p>
                        <p className="text_list">TRATAMENTO PARA CRIANÇAS (ODONTOPEDIATRIA)</p>
                        <p className="text_list">CONSULTAS</p>
                        <p className="text_list">RESTAURAÇÃO (DENTÍSTICA)</p>
                        <p className="text_list">LIMPEZA, PREVENÇÃO E APLICAÇÃO DE FLÚOR</p>
                      </Col>
                      <Col xs="12" sm="12" md="6" lg="6" xl="5" className="col_text2">
                        <p className="text_list">CIRURGIAS E EXTRAÇÕES</p>
                        <p className="text_list">RAIOS-X (PANORÂMICOS E PERIAPIPCAIS)</p>
                        <p className="text_list">TRATAMENTO DE CANAL (ENDODONTIA)</p>
                        <p className="text_list">TRATAMENTO DE GENGIVA (PERIODONTIA)</p>
                        <p className="text_list">RETIRADA DE PLACA BACTERIANA</p>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs="2" sm="1" md="1" lg="1" xl="1"
                        onMouseOver={this.coberturas.bind(this, true)} 
                        onMouseOut={this.coberturas.bind(this, false)}>
                      {this.state.coberturas == true ?(
                        <div onClick={this.next_carrossel.bind(this)} className="shape2">
                          <div className="arrow-right-hover">{""}</div>
                        </div>
                      ):(
                        <div onClick={this.next_carrossel.bind(this)} className="shape2">
                          <div className="arrow-right">{""}</div>
                        </div>
                      )}                
                    </Col>                   
                </Row>
              </div>
            </div>
          </div>
          ):('')}
          {/**-----------------CARENCIAS---------------- */}
          {this.state.carrossel == 1 ? (
            <div style={{marginTop:160}}>
              <div>{''}</div>
              <div className="carrossel">
                {/** icones */}
                <div className="carrossel_top">
                  <Row style={{margin:'auto', maxWidth:'95%'}} >
                    <Col>
                      <div onMouseMove={this.jumper_carrossel.bind(this, 1)} className="carrossel_icon_layout carrossel_icon2">{''}</div>
                      <p className="text_legend">CARÊNCIAS</p>
                    </Col>
                  </Row>
                </div>
                {/** conteudo */}
                <div className="carrossel_bottom">
                  <Row>
                    <Col xs="2" sm="1" md="1" lg="1" xl="1"
                        onMouseOver={this.carencias.bind(this, true)} 
                        onMouseOut={this.carencias.bind(this, false)}>
                      {this.state.carencias == true ?(
                        <div onClick={this.back_carrossel.bind(this)} className="shape2">
                          <div className="arrow-left-hover">{""}</div>
                        </div>
                      ):(
                        <div onClick={this.back_carrossel.bind(this)} className="shape2">
                          <div className="arrow-left">{""}</div>
                        </div>
                      )}                
                    </Col>     
                    <Col xs="8" sm="10" md="10" lg="10" xl="10">
                      <p className="title_carencia">CARÊNCIAS REDUZIDAS PARA PAGAMENTO NO CARTÃO DE CRÉDITO</p>
                      <Row >
                      
                        <Col  xl="10" className="col_text_carencia2" >
                          <table style={{width:'100%'}} >
                            <tbody>
                                <tr>
                                  <td className="td_family"><p className="text_list">URGÊNCIA E EMERGÊNCIA</p> </td>
                                  <td className="td_family" style={{textAlign:'center', width:'35%'}}><p className="text_list">1 MINUTO</p></td>
                                </tr>
                                <tr>
                                  <td className="td_family"><p className="text_list">DENTÍSTICA, RADIOLOGIA, DIAGNÓSTICO<br/> E ODONTOLOGIA PREVENTIVA</p></td>
                                  <td className="td_family" style={{textAlign:'center'}}><p className="text_list">1 MINUTO</p></td>
                                </tr>
                                <tr>
                                  <td className="td_family"><p className="text_list">PERIODONTIA E ENDODONTIA</p></td>
                                  <td className="td_family" style={{textAlign:'center'}}><p className="text_list">30 DIAS</p> </td>
                                </tr>
                                <tr>
                                  <td className="td_family"><p className="text_list">CIRURGIAS</p> </td>
                                  <td className="td_family" style={{textAlign:'center'}}><p className="text_list">60 DIAS</p></td>
                                </tr>
                                <tr>
                                  <td className="td_family"><p className="text_list">COROA</p> </td>
                                  <td className="td_family" style={{textAlign:'center'}}><p className="text_list" >180 DIAS</p></td>
                                </tr>                                
                            </tbody>
                          </table>
                        </Col>
                      </Row>  	                      
                      {/*}
                      <Row>
                        <Col xs="8" sm="8" md="8" lg="7" xl="7" className="col_text_carencia">
                          <p className="text_list">URGÊNCIA E EMERGÊNCIA</p>
                          <p className="text_list">DENTÍSTICA, RADIOLOGIA, DIAGNÓSTICO<br/> E ODONTOLOGIA PREVENTIVA</p>
                          <p className="text_list">PERIODONTIA E ENDODONTIA</p>
                          <p className="text_list">CIRURGIAS</p>    
                          <p className="text_list">COROA</p>                        

                        </Col>
                        <Col xs="4" sm="4" md="4" lg="5" xl="5" className="col_text_carencia2">
                          <p className="text_list">1 MINUTO</p>
                          <p className="text_list col_padding" style={{paddingTop:0}}>1 MINUTO</p>
                          <p className="text_list col_padding3" style={{paddingTop:0}}>30 DIAS</p>
                          <p className="text_list col_padding2" style={{paddingTop:0}}>60 DIAS</p>     
                          <p className="text_list col_padding2" style={{paddingTop:0}}>180 DIAS</p>                       

                        </Col>
                      </Row>
                      {*/}
                    </Col>
                    <Col xs="2" sm="1" md="1" lg="1" xl="1"
                        onMouseOver={this.carenciasRight.bind(this, true)} 
                        onMouseOut={this.carenciasRight.bind(this, false)}>
                      {this.state.carenciasRight == true ?(
                        <div onClick={this.next_carrossel.bind(this)} className="shape2">
                          <div className="arrow-right-hover">{""}</div>
                        </div>
                      ):(
                        <div onClick={this.next_carrossel.bind(this)} className="shape2">
                          <div className="arrow-right">{""}</div>
                        </div>
                      )}                
                    </Col>                  
                  </Row>
                </div>
              </div>
            </div>
          ):('')}
          {/**-----------------VANTAGENS---------------- */}
          {this.state.carrossel == 2 ? (
            <div style={{marginTop:160}}>
              <div>{''}</div>
              <div className="carrossel">
                {/** icones */}
                <div className="carrossel_top">
                  <Row style={{margin:'auto', maxWidth:'95%'}} >
                    <Col>
                      <div onMouseMove={this.jumper_carrossel.bind(this, 2)} className="carrossel_icon_layout carrossel_icon3">{''}</div>
                      <p className="text_legend">VANTAGENS</p>
                    </Col>
                  </Row>
                </div>
                {/** conteudo */}
                <div className="carrossel_bottom">
                  <Row>
                    <Col xs="2" sm="1" md="1" lg="1" xl="1"
                        onMouseOver={this.vantagens.bind(this, true)} 
                        onMouseOut={this.vantagens.bind(this, false)}>
                      {this.state.vantagens == true ?(
                        <div onClick={this.back_carrossel.bind(this)} className="shape2">
                          <div className="arrow-left-hover">{""}</div>
                        </div>
                      ):(
                        <div onClick={this.back_carrossel.bind(this)} className="shape2">
                          <div className="arrow-left">{""}</div>
                        </div>
                      )}                
                    </Col>                  
                    <Col xs="8" sm="10" md="10" lg="10" xl="10">
                      <Row>
                        <Col xl={12} className="col_text_vantagens">
                          <p className="text_list">AMPLA REDE DE DENTISTAS</p>
                          <p className="text_list">ATENDIMENTO EM CLÍNICAS PARTICULARES</p>
                          <p className="text_list">LIBERAÇÃO ONLINE DE PROCEDIMENTOS</p>
                          <p className="text_list">MATERIAIS COM ALTO PADRÃO DE QUALIDADE</p>
                          <p className="text_list">COBERTURA TOTAL PARA MAIS DE 150 PROCEDIMENTOS CLÍNICOS</p>
                        </Col>                      
                      </Row>
                    </Col>
                    <Col xs="2" sm="1" md="1" lg="1" xl="1"
                         onMouseOver={this.vantagensRight.bind(this, true)} 
                         onMouseOut={this.vantagensRight.bind(this, false)}>
                      {this.state.vantagensRight == true ?(
                        <div onClick={this.next_carrossel.bind(this)} className="shape2">
                          <div className="arrow-right-hover">{""}</div>
                        </div>
                      ):(
                        <div onClick={this.next_carrossel.bind(this)} className="shape2">
                          <div className="arrow-right">{""}</div>
                        </div>
                      )}                
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          ):('')}
          {/**-----------------TABELA FAMILIA---------------- */}
          {this.state.carrossel == 3 ? (
            <div style={{marginTop:160}}>
              <div>{''}</div>
              <div className="carrossel">
                {/** icones */}
                <div className="carrossel_top">
                  <Row style={{margin:'auto', maxWidth:'95%'}} >
                    <Col>
                      <div onMouseMove={this.jumper_carrossel.bind(this, 3)} className="carrossel_icon_layout carrossel_icon4">{''}</div>
                      <p className="text_legend">TABELA FAMÍLIA</p>
                    </Col>
                  </Row>
                </div>
                {/** conteudo */}
                <div className="carrossel_bottom">
                  <Row>
                    <Col xs="1" sm="1" md="1" lg="1" xl="1"
                        onMouseOver={this.familia.bind(this, true)} 
                        onMouseOut={this.familia.bind(this, false)}>
                      {this.state.familia == true ?(
                        <div onClick={this.back_carrossel.bind(this)} className="shape2">
                          <div className="arrow-left-hover">{""}</div>
                        </div>
                      ):(
                        <div onClick={this.back_carrossel.bind(this)} className="shape2">
                          <div className="arrow-left">{""}</div>
                        </div>
                      )}                
                    </Col>                  
                    <Col xs="10" sm="10" md="10" lg="10" xl="10">
                      <p className="title_table_family">DESCONTOS A PARTIR DE 2 BENEFICIÁRIOS</p>
                      <p className="title_table_family2">VÁLIDO PARA PAGAMENTOS NO CARTÃO DE CRÉDITO</p>
                      <Row>
                        <Col xs="12" sm="12" md="12" lg="12" xl="12" className="col_text_family">
                          <table className="table-responsive">
                            <thead>
                                <tr >
                                    <th>{''}</th>
                                    <th style={{textAlign:'center', paddingLeft:0}}><div className="th_family">VALOR UNITÁRIO</div></th>
                                    <th style={{textAlign:'center', paddingLeft:10}}><div className="th_family">VALOR TOTAL</div></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                  <td className="td_family">1 BENEFICIÁRIO <hr className="hr_family"/></td>
                                  <td className="td_family" style={{textAlign:'center'}}>R$<span className="td_span">33</span>,90</td>
                                  <td className="td_family">{''}</td>
                                </tr>
                                <tr>
                                  <td className="td_family">2 BENEFICIÁRIOS <hr className="hr_family2"/></td>
                                  <td className="td_family" style={{textAlign:'center'}}>R$<span className="td_span">31</span>,50 <hr className="hr_family4"/></td>
                                  <td className="td_family" style={{textAlign:'center'}}>R$<span className="td_span">63</span>,00</td>
                                </tr>
                                <tr>
                                  <td className="td_family">3 BENEFICIÁRIOS <hr className="hr_family2"/></td>
                                  <td className="td_family" style={{textAlign:'center'}}>R$<span className="td_span">28</span>,30 <hr className="hr_family4"/></td>
                                  <td className="td_family" style={{textAlign:'center'}}>R$<span className="td_span">84</span>,90</td>
                                </tr>
                                <tr>
                                  <td className="td_family">4 BENEFICIÁRIOS OU MAIS <hr className="hr_family3"/></td>
                                  <td className="td_family" style={{textAlign:'center'}}>R$<span className="td_span">28</span>,30</td>
                                  <td className="td_family">{''}</td>
                                </tr>
                            </tbody>
                          </table>
                        </Col>
                      </Row>
                    </Col>
                    <Col xs="1" sm="1" md="1" lg="1" xl="1">
                      {""}             
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          ):('')}
        </div>
        
         
         
         
         
        <hr className="hr_style"/>
        
      </div>
    );

  }

}

export default DentalVip;



/** WEBPACK FOOTER **
 ** ./src/components/HomePageNew/DentalVip.js
 **/